import { render, staticRenderFns } from "./FuturePaymentStudentList.vue?vue&type=template&id=2b92faf0"
import script from "./FuturePaymentStudentList.vue?vue&type=script&lang=js"
export * from "./FuturePaymentStudentList.vue?vue&type=script&lang=js"
import style0 from "./FuturePaymentStudentList.vue?vue&type=style&index=0&id=2b92faf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports